import { createContext, useContext, ReactNode } from 'react';

// Import types
import type { PacketWithPriceAndChannels } from 'types/views/configurator';
import type { CalculatedPriceProduct } from 'types/api/packetsSubscription';

type Props = {
	children: ReactNode;
	packet: PacketWithPriceAndChannels;
	isCurrent: boolean;
	isSelected: boolean;
	isSubscriptionModification: boolean;
	onSelect: () => void;
	isPricesLoading: boolean;
	expires_on: string | undefined;
	isCanceled: boolean;
	isAnyPromotion: boolean;
	calculatedPrice: CalculatedPriceProduct | undefined;
	columns?: string[];
};

type ContextType = Omit<Props, 'children'>;

export const MainPacketContext = createContext<ContextType>({} as ContextType);

export const useMainPacketContext = () => useContext(MainPacketContext);

const MainPacketProvider = ({ children, ...props }: Props) => <MainPacketContext.Provider value={props}>{children}</MainPacketContext.Provider>;

export default MainPacketProvider;
